import React, { useState, useEffect } from "react";
import { apiPost } from "../../API/Api_Url";
import { toast } from "react-toastify";

function FreelancerPaymentModeModal1({
  isOpen,
  onClose,
  SelectedRequirement,
  GetContractorAllFreelancerInConstructionJobPost,
}) {
  const [mode, setMode] = useState("Milestone");
  const [milestones, setMilestones] = useState([
    { Title: "", Amount: "", DueDate: "" },
  ]);
  const [hourlyRate, setHourlyRate] = useState("");
  const [dailyRate, setDailyRate] = useState("");
  const [lumpSumAmount, setLumpSumAmount] = useState("");

  useEffect(() => {
    if (isOpen && SelectedRequirement?.PaymentFlow) {
      const pf = SelectedRequirement.PaymentFlow;
      setMode(pf.Mode);

      if (pf.Mode === "Milestone") {
        setMilestones([
          ...pf.Milestones.map((m) => ({
            Title: m.Title,
            Amount: m.Amount,
            DueDate: m.DueDate?.split("T")[0] || "",
            existing: true, 
          })),
          { Title: "", Amount: "", DueDate: "" },
        ]);
      } else if (pf.Mode === "Hourly") {
        setHourlyRate(pf.HourlyRate || "");
      } else if (pf.Mode === "Daily") {
        setDailyRate(pf.DailyRate || "");
      } else if (pf.Mode === "LumpSum") {
        setLumpSumAmount(pf.LumpSumAmount || "");
      }
    }
  }, [isOpen, SelectedRequirement]);

  const handleAddMilestone = () => {
    setMilestones([
      ...milestones,
      { Title: "", Amount: "", DueDate: "" },
    ]);
  };

  const handleRemoveMilestone = (index) => {

    if (milestones[index].existing) {
      toast.error("You cannot remove an existing milestone.");
      return;
    }
    setMilestones(milestones.filter((_, i) => i !== index));
  };

  const handleMilestoneChange = (index, field, value) => {
    const updated = [...milestones];
    updated[index][field] = value;
    setMilestones(updated);
  };

  const UserAddOrUpdatePaymentFlow = async () => {
    try {
      if (!mode) {
        toast.error("Please select a payment mode.");
        return;
      }

      if (mode === "Milestone" && milestones.length === 0) {
        toast.error("Please add at least one new milestone.");
        return;
      }

      for (let i = 0; i < milestones.length; i++) {
        const m = milestones[i];
        if (!m.Title?.trim()) {
          toast.error(`Milestone ${i + 1}: Title is required.`);
          return;
        }
        if (!m.Amount || isNaN(m.Amount) || Number(m.Amount) <= 0) {
          toast.error(`Milestone ${i + 1}: Amount must be greater than 0.`);
          return;
        }
        if (!m.DueDate) {
          toast.error(`Milestone ${i + 1}: Due date is required.`);
          return;
        }
      }

      const payload = {
        Mode: mode,
        Milestones: mode === "Milestone" ? milestones : [],
        HourlyRate: mode === "Hourly" ? Number(hourlyRate) : null,
        DailyRate: mode === "Daily" ? Number(dailyRate) : null,
        LumpSumAmount: mode === "LumpSum" ? Number(lumpSumAmount) : null,
      };

      const response = await apiPost(
        `api/contractor/contractorAddOrUpdatePaymentFlow/${SelectedRequirement?._id}`,
        payload
      );

      toast.success(response?.message || "Bid Finalize completed");
      onClose();
      GetContractorAllFreelancerInConstructionJobPost();
    } catch (error) {
      console.error("Error saving PaymentFlow:", error);
      toast.error("Something went wrong, please try again.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-2xl p-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Select Payment Mode
        </h2>

        <select
          value={mode}
          onChange={(e) => setMode(e.target.value)}
          className="w-full border rounded-lg px-3 py-2 mb-4"
        >
          <option value="">Please select</option>
          <option value="Milestone">Milestone</option>
          <option value="Hourly">Hourly</option>
          <option value="Daily">Daily</option>
          <option value="LumpSum">Lump Sum</option>
        </select>
        {mode === "Milestone" && (
          <div className="space-y-4 max-h-80 overflow-y-auto">
            {milestones.map((m, i) => (
              <div
                key={i}
                className="p-4 border rounded-lg bg-gray-50 space-y-2 relative"
              >
                {!m.existing && (
                  <button
                    type="button"
                    onClick={() => handleRemoveMilestone(i)}
                    className="absolute top-2 right-2 text-red-500 hover:text-red-700"
                  >
                    ✕
                  </button>
                )}
                <input
                  type="text"
                  placeholder="Milestone Title"
                  value={m.Title}
                  onChange={(e) =>
                    handleMilestoneChange(i, "Title", e.target.value)
                  }
                  className="w-full border rounded px-3 py-2"
                />
                <input
                  type="number"
                  placeholder="Amount"
                  value={m.Amount}
                  onChange={(e) =>
                    handleMilestoneChange(i, "Amount", e.target.value)
                  }
                  className="w-full border rounded px-3 py-2"
                />
                <input
                  type="date"
                  value={m.DueDate}
                  onChange={(e) =>
                    handleMilestoneChange(i, "DueDate", e.target.value)
                  }
                  className="w-full border rounded px-3 py-2"
                />
                {m.existing && (
                  <p className="text-xs text-gray-500 italic">Already saved</p>
                )}
              </div>
            ))}
            <button
              onClick={handleAddMilestone}
              className="px-4 py-2 rounded-lg bg-blue-500 text-white hover:bg-blue-600"
            >
              + Add Milestone
            </button>
          </div>
        )}

        {mode === "Hourly" && (
          <input
            type="number"
            placeholder="Hourly Rate"
            value={hourlyRate}
            onChange={(e) => setHourlyRate(e.target.value)}
            className="w-full border rounded px-3 py-2"
          />
        )}
        {mode === "Daily" && (
          <input
            type="number"
            placeholder="Daily Rate"
            value={dailyRate}
            onChange={(e) => setDailyRate(e.target.value)}
            className="w-full border rounded px-3 py-2"
          />
        )}
        {mode === "LumpSum" && (
          <input
            type="number"
            placeholder="Lump Sum Amount"
            value={lumpSumAmount}
            onChange={(e) => setLumpSumAmount(e.target.value)}
            className="w-full border rounded px-3 py-2"
          />
        )}

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={UserAddOrUpdatePaymentFlow}
            className="px-4 py-2 rounded-lg bg-green-500 text-white hover:bg-green-600"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default FreelancerPaymentModeModal1;
